import { render, staticRenderFns } from "./NewTemplateButton.vue?vue&type=template&id=e4e60120&"
import script from "./NewTemplateButton.vue?vue&type=script&lang=ts&"
export * from "./NewTemplateButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports